import React, { useEffect, useState, useImperativeHandle, forwardRef } from "react";

export const  CheckBox = forwardRef((props, ref) => {
    const [firstRender, setFirstRender] = useState(true);
    const [checked, setChecked] = useState(props.value == 1 ? true : false);
    const checkboxRef = React.createRef();

   useEffect(() => {
        if(firstRender) {
            setFirstRender(false);
            return;
        }
        props.onChange(checked ? 1 : null);
    }, [checked]);

    const onChange = () => {
        setChecked(() => setChecked((checked) => !checked));
    }

    const tooltip = () => {

    }

    useImperativeHandle(ref, () => ({
        unCheck() {
            setChecked((checked) => false);
        }
    }))

    return(
        <div className={props.className ? props.className : ''}>
            <label key="label" className="flex items-center">
                <input
                id={props.id ? props.id : ''}
                className="relative blue2"
                ref={ref ? ref : checkboxRef}
                key="checkbox"
                type="checkbox"
                value={props.value}
                checked={checked}
                disabled={props.disabled}
                onChange={onChange}
                /><div key="label" className="ucfirst">{props.label}</div>
            </label>
        </div>
    );
});
